import React, { useState, useEffect } from 'react';
import LoginPage from './components/LoginPage';
import Dashboard from './components/dashboard/Dashboard';
import EditRecordModal from './components/EditRecordModal';  // index.jsx 자동 로드
import DBManagement from './components/management/DBManagement';
import UserManagement from './components/management/UserManagement';
import PasswordChange from './components/management/PasswordChange';
import TemplateManagement from './components/management/TemplateManagement';
import MaterialManagement from './components/management/MaterialManagement';
import GoogleDrive from './components/GoogleDrive';
import { commonStyles } from './styles/commonStyles';
import { useAuth } from './hooks/useAuth';

function App() {
  const { token, userRole, login, logout } = useAuth();
  const [activeTab, setActiveTab] = useState('dashboard');

  // body margin/padding 제거
  useEffect(() => {
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    document.body.style.overflow = 'hidden';
  }, []);

  // 문서공간 새 탭으로 열기
  const handleDriveClick = () => {
    window.open('https://drive.google.com/drive/folders/19L3IyjRVFyPDNiVuJejq2QudBQ_ZQrgB', '_blank');
  };

  // 원격제어 새 탭으로 열기
 const handleRemoteClick = () => {
  window.open('https://mesh.pctools.myds.me', '_blank');
};

  // 로그인하지 않은 경우 로그인 페이지 표시
  if (!token) {
    return <LoginPage onLoginSuccess={login} />;
  }

  return (
    <div style={commonStyles.container}>
      {/* 상단 헤더 및 네비게이션 */}
      <header style={commonStyles.header}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <h1 
            style={{ ...commonStyles.title, cursor: 'pointer' }} 
            onClick={() => setActiveTab('dashboard')}
          >
            PCTOOLS
          </h1>
          <nav style={commonStyles.headerButtons}>
            <button 
              onClick={() => setActiveTab('dashboard')} 
              style={{...commonStyles.navButton, ...(activeTab === 'dashboard' ? commonStyles.navButtonActive : {})}}
            >
              작업현황
            </button>
            <button 
              onClick={() => setActiveTab('materials')} 
              style={{...commonStyles.navButton, ...(activeTab === 'materials' ? commonStyles.navButtonActive : {})}}
            >
              자재관리
            </button>
            {/* DB관리는 관리자만 표시 */}
            {userRole === 'admin' && (
              <button 
                onClick={() => setActiveTab('db')} 
                style={{...commonStyles.navButton, ...(activeTab === 'db' ? commonStyles.navButtonActive : {})}}
              >
                DB관리
              </button>
            )}
            <button 
              onClick={() => setActiveTab('users')} 
              style={{...commonStyles.navButton, ...(activeTab === 'users' ? commonStyles.navButtonActive : {})}}
            >
              계정관리
            </button>
            <button 
              onClick={() => setActiveTab('templates')} 
              style={{...commonStyles.navButton, ...(activeTab === 'templates' ? commonStyles.navButtonActive : {})}}
            >
              문서템플릿
            </button>
            <button 
              onClick={handleDriveClick}
              style={commonStyles.navButton}
            >
              문서공간
            </button>
            {/* 원격지원 - 관리자만 표시 */}
            {userRole === 'admin' && (
              <button 
                onClick={handleRemoteClick}
                style={commonStyles.navButton}
              >
                원격지원
              </button>
            )}
          </nav>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <span style={{ fontSize: '14px', color: '#ecf0f1' }}>
            [{userRole === 'admin' ? '관리자' : '사용자'}]님 반갑습니다
          </span>
          <button onClick={logout} style={commonStyles.logoutButton}>로그아웃</button>
        </div>
      </header>

      {/* 메인 컨텐츠 영역 (탭 기반 라우팅) */}
      <main style={{ padding: '0', flex: 1, overflow: 'hidden' }}>
        {(() => {
          switch (activeTab) {
            case 'dashboard':
              return <Dashboard token={token} />;
            case 'materials':
              return <MaterialManagement token={token} />;
            case 'db':
              // DB관리는 관리자만 접근 가능
              return userRole === 'admin' ? <DBManagement token={token} /> : <Dashboard token={token} />;
            case 'templates':
              return <TemplateManagement token={token} />;
            case 'users':
              return userRole === 'admin' ? <UserManagement token={token} /> : <PasswordChange token={token} />;
            default:
              return <Dashboard token={token} />;
          }
        })()}
      </main>
    </div>
  );
}

export default App;